import { GroupBase, PlaceholderProps, components } from "react-select5";

export function PlaceholderComponent<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: PlaceholderProps<Option, IsMulti, Group> & { hidePlaceholderOnFocus?: boolean }
) {
  return (
    <components.Placeholder
      {...props}
      children={props.hidePlaceholderOnFocus && props.isFocused ? "" : props.children}
    ></components.Placeholder>
  );
}
